<template>
  <div id="main" :class="settingStyle">
    <component :is="layout" />
  </div>
</template>

<script>
import Full from "@/layout/Full";
import Tabs from "@/layout/Tabs";
import Split from "@/layout/Split";
import Web from "@/layout/Web";
import updateMixin from "@/update.js";
import Icons from "@/components/annot8/icons";

export default {
  name: "App",
  data() {
    return {};
  },
  computed: {
    layout() {
      if(!this.$config.mobile) {
        return "Web";
      }
      return this.$store.state.ui.layout || "Tabs";
    },
    settingStyle() {
      return [
        "mode-" +
          (this.$store.state.settings.settings.theme || "normal")
      ];
    }
  },
  methods: {
    async shareTo(url, text) {
      const t = `<div class="social-alert">
            <h6 class="label">${text}</h6>
            <div class="tooltip" onClick="copyLink('${url}')"><span class="text">${url}</span><span class="icon">${Icons['si-entypo-copy']}</span>
            <span class="tooltiptext">Copy Link</span></div>
            <div style='padding: 0.5em;'>
            The user must signed in to view the content.</div>
          </div>`;

      await this.$ionic.showAlert(t,
        {
          cssClass: "medium-width-alert",
          header: "Share",
          buttons: [
            "Close"
          ]
        }
      );
    },

    copyLink(url) {
      const cb = navigator.clipboard;
      cb.writeText(url).then(() => {
          this.$ionic.showToast("Link Copied.", {
          position: "bottom"
          });
      });
    }
  },
  components: {
    Full: Full,
    Tabs: Tabs,
    Split: Split,
    Web: Web
  },
  mixins: [updateMixin],
  mounted() {
    // this.getUser();
    window.shareTo = this.shareTo;
    window.copyLink = this.copyLink;
  }
};
</script>

<style lang="scss">
@import '@/assets/app.scss';
@import '@/assets/print.scss';
</style>
